angular.module('qkr.department')
    .component('page', {
        template: require('./page.html'),
        transclude: {
            header: 'pageHeader',
            body: 'pageBody'
        }
    });



// WEBPACK FOOTER //
// ./src/shared/page.component.js